var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PreventableEvent } from './PreventableEvent';
/**
 * The `SortableOnDragStartEvent` event.
 */
var SortableOnDragStartEvent = /** @class */ (function (_super) {
    __extends(SortableOnDragStartEvent, _super);
    /**
     * @hidden
     */
    function SortableOnDragStartEvent(target, prevIndex, element) {
        var _this = _super.call(this) || this;
        _this.target = target;
        _this.prevIndex = prevIndex;
        _this.element = element;
        return _this;
    }
    return SortableOnDragStartEvent;
}(PreventableEvent));
export { SortableOnDragStartEvent };
//# sourceMappingURL=SortableOnDragStartEvent.js.map